// extracted by mini-css-extract-plugin
module.exports = {"resultBox":"SearchResultsUi-module--resultBox--3YtrW"};